import { AxiosError } from "axios";
import { ReactText } from "react";
import { toast } from "react-toastify";
import { MdmApiError } from "./MdmApiError";

export const apiErrorNotificationToast = (error: AxiosError<MdmApiError>): ReactText => {
  const apiError = error.response?.data;
  return toast.error(
    apiError?.title ?? apiError?.detail ?? `Unknown error with status code ${apiError?.status}`
  );
};
